import { createContext, useContext, useState, useEffect } from 'react';
import API from '../api/axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const saved = localStorage.getItem('user');
    if (token && saved) {
      setUser(JSON.parse(saved));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await API.post('/auth/login', { email, password });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
  };

  const sendVerificationCode = async (email) => {
    await API.post('/auth/send-verification-code', { email });
  };

  const signup = async (email, password, name, orgName, verificationCode) => {
    const { data } = await API.post('/auth/signup', { email, password, name, orgName, verificationCode });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const forgotPassword = async (email) => {
    await API.post('/auth/forgot-password', { email });
  };

  const resetPassword = async (email, code, newPassword) => {
    await API.post('/auth/reset-password', { email, code, newPassword });
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, sendVerificationCode, forgotPassword, resetPassword, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
